import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from '../global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
const devUrl = environment.backendurl

@Injectable({
    providedIn: 'root'
})

export class TagManagementService {

    constructor(private http: HttpClient) { }

    /**
      * Get User Details
      * @param userid 
      * @returns 
      */
    fetchUserDetails(userid: string) {
        const url = devUrl + '/user/fetchdetails';
        const params = new HttpParams().set('usernumber', userid)
        return this.http.get(url, { params }).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Get profile details data', url)))
    };


    /**
     * Create New Tag
     * @param data 
     * @returns 
     */
    createTags(data: any) {
        const url = devUrl + '/candidate/tag';
        return this.http.post(url, data).pipe(map((response) => { return response; }),
            catchError(GlobalService.handleError('Create New Tag Against User', url)))
    }


    /**
     * Get User All Tags
     * @param data
     * @returns 
     */
    getAllTags(data: any) {
        const url = devUrl + '/tags';
        const params = new HttpParams().set('tagtext', data.tagtext);
        return this.http.get(url, { params }).pipe(map((response) => { return response; }),
            catchError(GlobalService.handleError('Get User All Tags', url)))
    };


    /**
      * Edit User Tag
      * @param data 
      * @returns 
      */
    editTags(data: any) {
        const url = `${devUrl}/user/edittag/${data.tagid}`;
        const body = { tagtext: data.tagtext };
        return this.http.patch(url, body).pipe(
            map((response) => response),
            catchError(GlobalService.handleError('Edit User Tag', url))
        );
    };

    /**
     * Delete User Tag
     * @param data 
     * @returns 
     */
    deleteTags(data: any) {
        const url = devUrl + `/user/deletetag/${data.tagid}`;
        return this.http.patch(url, {}).pipe(map((response) => { return response; }),
            catchError(GlobalService.handleError('Delete User Tag', url)))
    };

};